export default __webpack_public_path__ + "static/ml-ab41d1d98db2eaa80cfdab3ecb14eacb.svg";